module.exports = "<app-i18n-toggle-translated-text text=$ctrl.field[$ctrl.mainLang] main-lang=$ctrl.mainLang> </app-i18n-toggle-translated-text> <input type=text class=form-control placeholder=\"{{ $ctrl.placeholder }}\" minlength=\"{{ $ctrl.minlength }}\" maxlength=\"{{ $ctrl.maxlength }}\" ng-required=$ctrl.required ng-model=$ctrl.getSet ng-model-options=\"{getterSetter: true}\" name={{$ctrl.name}}> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/i18n/input_partial.html
// module id = 544
// module chunks = 0